import { SupplementForm } from "~/components/form/health-profile/SupplementForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateSupplement() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="supplements">
            <SupplementForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
